/**
 * @file コンポーネント：症例アイテム DOM管理
 */

// ライブラリ読み込み
import React from "react";
import { useEffect } from "react";

// コンポーネント読み込み
import { Surgeonlist } from "~/src/components/projects/Surgeonlist";
import { OperationLabellist } from "~/src/components/uiparts/OperationLabellist";
import { OperationThumbnailImage } from "~/src/components/uiparts/OperationThumbnailImage";
import { OperationThumbnailVideo } from "~/src/components/uiparts/OperationThumbnailVideo";
import { Price } from "~/src/components/uiparts/Price";

// スタイル読み込み
import {
    StyledOperation,
    StyledOperationDate,
    StyledOperationDescription,
    StyledOperationMetalist,
    StyledOperationMetalistDetail,
    StyledOperationMetalistItem,
    StyledOperationMetalistTerm,
    StyledOperationPrice,
    StyledOperationPurchaseDate,
    StyledOperationPurchaseId,
    StyledOperationSurgeonlist,
    StyledOperationThumbnail,
    StyledOperationThumbnailAnchor,
    StyledOperationThumbnailImage,
    StyledOperationThumbnailImageAnimation,
    StyledOperationTitle,
    StyledOperationTitleAnchor,
    StyledOperationIconMetalist,
    StyledOperationIconMetalistItem,
    StyledOperationIconMetalistTermAnotherTab,
    StyledOperationIconMetalistTermPromotion,
} from "./style";

// 関数読み込み
import { fnReplaceLocalizedText } from "~/src/functions/common";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    useEffect(() => {
        if (props.promotionId != null) {
            props.fnUpdateViewCount(props.promotionId);
        }
    }, []); // マウント時に一度だけ実行

    // ReactDOM
    return (
        <StyledOperation className={props.canEdit && "is-canedit"}>
            {/* 症例タイトル */}
            <StyledOperationTitle>
                <props.tagTitle>
                    <StyledOperationTitleAnchor
                        href={props.link}
                        target={props.anotherTabFlag ? "_blank" : undefined}
                        onClick={(e) => {
                            if (!window.dataUser.isLogin) {
                                // SEO対応：ログイン前でも症例画面を開くため、にログインモーダルを出す処理を削除
                            } else  {
                                // ログイン時、クリックカウントを計測
                                props.fnUpdateClickCount(props.promotionId, props.id);
                            }
                            // Google Tag Manager カスタムイベントトリガー
                            props.fnPushDataLayerAdClickCount();
                        }}
                    >
                        {props.title}
                    </StyledOperationTitleAnchor>
                </props.tagTitle>
            </StyledOperationTitle>
            {/* 症例サムネイル */}
            <StyledOperationThumbnail>
                <StyledOperationThumbnailAnchor
                    href={props.link}
                    target={props.anotherTabFlag ? "_blank" : undefined}
                    onClick={(e) => {
                        if (!window.dataUser.isLogin) {
                            // SEO対応：ログイン前でも症例画面を開くため、にログインモーダルを出す処理を削除
                        } else  {
                            // ログイン時、クリックカウントを計測
                            props.fnUpdateClickCount(props.promotionId, props.id);
                        }
                        // Google Tag Manager カスタムイベントトリガー
                        props.fnPushDataLayerAdClickCount();
                    }}
                >
                    {props.labellist &&
                    (props.labellist.indexOf("sponsor") !== -1 ||
                        props.labellist.indexOf("promotion") !== -1) ? (
                        // スポンサーコンテンツ、プロモーションの場合
                        props.thumbnailContentType === 1 ? (
                            // 動画の場合
                            <OperationThumbnailVideo {...props} />
                        ) : (
                            // 画像の場合
                            <OperationThumbnailImage {...props} />
                        )
                    ) : (
                        // 通常の症例の場合
                        <>
                            <StyledOperationThumbnailImage
                                alt={props.title}
                                src={props.thumbnail}
                            />
                            {props.thumbnailAnimation &&
                                window.dataUser.isLogin && (
                                    // ログイン中かつアニメーション画像がある場合
                                    <StyledOperationThumbnailImageAnimation
                                        alt={props.title}
                                        src={props.thumbnailAnimation}
                                    />
                                )}
                        </>
                    )}
                    {/* 症例ラベルリスト */}
                    {props.labellist && props.labellist.length > 0 && (
                        <OperationLabellist
                            isOperation={props.isOperation}
                            labellist={props.labellist}
                        />
                    )}
                </StyledOperationThumbnailAnchor>
            </StyledOperationThumbnail>
            {/* 購入日時 */}
            {props.purchaseDate && (
                <StyledOperationPurchaseDate>
                    {fnReplaceLocalizedText(localized["Label.PurchaseDate"], [
                        props.purchaseDate,
                    ])}
                </StyledOperationPurchaseDate>
            )}
            {/* 購入管理ID */}
            {props.purchaseId && (
                <StyledOperationPurchaseId>
                    {localized["Label.PurchaseId"] + " " + props.purchaseId}
                </StyledOperationPurchaseId>
            )}
            {/* アップデート日時 */}
            <StyledOperationDate>{props.date}</StyledOperationDate>
            {/* 執刀医リスト */}
            {props.surgeonlist && (
                <StyledOperationSurgeonlist>
                    <Surgeonlist
                        onColor="white"
                        surgeonlist={props.surgeonlist}
                    />
                </StyledOperationSurgeonlist>
            )}
            {/* 価格 */}
            {props.price && (
                <StyledOperationPrice>
                    <Price
                        isPurchased={props.isPurchased}
                        price={props.price}
                    />
                </StyledOperationPrice>
            )}
            {props.view !== null &&
                props.view !== undefined &&
                props.rate !== null &&
                props.rate !== undefined && (
                    <StyledOperationMetalist>
                        {/* 閲覧数 */}
                        {props.view !== null && props.view !== undefined && (
                            props.isCollaboration ? (
                                <StyledOperationMetalistItem>
                                    <StyledOperationMetalistTerm
                                        title={localized["Label.ViewCount"]}
                                    >
                                    </StyledOperationMetalistTerm>
                                </StyledOperationMetalistItem>
                            ) : (
                                <StyledOperationMetalistItem>
                                    <StyledOperationMetalistTerm
                                        title={localized["Label.ViewCount"]}
                                    >
                                        <i className="fas fa-eye"></i>
                                    </StyledOperationMetalistTerm>
                                    <StyledOperationMetalistDetail>
                                        {props.view.toLocaleString()}
                                    </StyledOperationMetalistDetail>
                                </StyledOperationMetalistItem>
                            )
                        )}
                        {/* 評価数 */}
                        {props.rate !== null && props.rate !== undefined && (
                            props.isCollaboration ? (
                            <StyledOperationMetalistItem>
                                <StyledOperationMetalistTerm
                                    title={localized["Label.RatingCount"]}
                                >
                                </StyledOperationMetalistTerm>
                            </StyledOperationMetalistItem>
                            ) : (
                            <StyledOperationMetalistItem>
                                <StyledOperationMetalistTerm
                                    title={localized["Label.RatingCount"]}
                                >
                                    <i className="fas fa-thumbs-up"></i>
                                </StyledOperationMetalistTerm>
                                <StyledOperationMetalistDetail>
                                    {props.rate.toLocaleString()}
                                </StyledOperationMetalistDetail>
                            </StyledOperationMetalistItem>
                            )
                        )}
                    </StyledOperationMetalist>
                )}
            {/* 説明文（非症例プロモーションのみ） */}
            {props.isOperation === false && props.description && (
                <StyledOperationDescription>
                    {props.description}
                </StyledOperationDescription>
            )}
            {(props.anotherTabFlag === true || props.labellist ) && (
                <StyledOperationIconMetalist>
                    {/* 症例ラベルリスト */}
                    {props.labellist &&
                        props.labellist.indexOf("sponsor") !== -1 && (
                        <StyledOperationIconMetalistItem>
                            <StyledOperationIconMetalistTermPromotion
                                title="sponsor"
                            >
                                PR
                            </StyledOperationIconMetalistTermPromotion>
                        </StyledOperationIconMetalistItem>
                    )}
                    {/* 外部アイコン */}
                    {props.anotherTabFlag === true && (
                        <StyledOperationIconMetalistItem>
                            <StyledOperationIconMetalistTermAnotherTab
                                title={localized["Label.ExternalSite"]}
                            >
                                <i className="fas fa-external-link-alt"></i>
                            </StyledOperationIconMetalistTermAnotherTab>
                        </StyledOperationIconMetalistItem>
                    )}
                </StyledOperationIconMetalist>
            )}
        </StyledOperation>
    );
};
